<template>
  <AgentService :mcs-service-mode="2" />
</template>

<script>
import AgentService from '@telexpress_auth/vue-agentservice/dist/components/agentservice.umd.min';
import '@telexpress_auth/vue-agentservice/dist/components/agentservice.css';

export default {
  components: {
    AgentService,
  },

};
</script>
